import { call, fork, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';

import history from '../history';
import * as types from '../constants/actionTypes';
import actions from '../actions';
import api from '../lib/api';
import notify from '../lib/notify';

export function* createDriverSelfRatingSaga(action) {
  try {
    yield put(actions.form.createDriverSelfRatingLoading());
    const data = yield call(api.ratingSelf.create, action.data, action.formType);
    yield put(actions.form.createDriverSelfRatingSuccess(data));

    if (!_.includes(action.formType, ['practice', 'qualifying', 'race', 'reflection', 'dirt', 'training'])) {
      yield put(actions.form.removeNonHeaderFields('ratingSelf'));
    }
    history.push(_.get(action, 'redirectTo', '/confirmation/rating'));
  } catch (e) {
    yield put(actions.form.createDriverSelfRatingError());
    yield call(notify, e);
  }
}

export function* fetchDriverSelfRatingOptionsSaga(action) {
  try {
    yield put(actions.ui.setRatingType('ratingSelf'));
    yield put(actions.form.fetchDriverSelfRatingOptionsLoading());
    const data = yield call(api.ratingSelf.options, action.formType);
    yield put(actions.form.fetchDriverSelfRatingOptionsSuccess(data));
    yield put(actions.validation.updateRules('ratingSelf', data));
  } catch (e) {
    yield put(actions.form.fetchDriverSelfRatingOptionsError());
    yield call(notify, e);
  }
}

export function* watchCreateDriverSelfRatingSaga() {
  yield takeLatest(types.CREATE_DRIVER_SELF_RATING, createDriverSelfRatingSaga);
}

export function* watchFetchDriverSelfRatingOptionsSaga() {
  yield takeLatest(types.FETCH_DRIVER_SELF_RATING_OPTIONS, fetchDriverSelfRatingOptionsSaga);
}

export default [
  fork(watchCreateDriverSelfRatingSaga),
  fork(watchFetchDriverSelfRatingOptionsSaga),
];
